import React from 'react';
import { FiHeart, FiMessageCircle, FiEye } from 'react-icons/fi';
import type { ChannelMediaResponse } from '@troia-v3/types';

import { formatCompact } from './formatMetrics';

const Thumb: React.FC<{ media: ChannelMediaResponse }> = ({ media }) => {
  const first = media.assets[0];
  if (!first) return <div className="cdash-gmedia" />;
  return (
    <div className="cdash-gmedia">
      {first.storedImageUrl ? <img src={first.storedImageUrl} alt={media.caption ?? ''} /> : first.type === 'video' ? <video src={first.mediaUrl} muted /> : <img src={first.mediaUrl} alt={media.caption ?? ''} />}
    </div>
  );
};

export const MediaGallery: React.FC<{ items: ChannelMediaResponse[] }> = ({ items }) => {
  if (items.length === 0) {
    return (
      <div className="cdash-empty" data-testid="cdash-gallery-empty">
        <div className="cdash-empty-t">Nenhuma publicação ainda</div>
        <div className="cdash-empty-d">Os posts sincronizados do Instagram aparecem aqui após o sync.</div>
      </div>
    );
  }
  return (
    <div className="cdash-gallery" data-testid="cdash-gallery">
      {items.map((m) => {
        const stats = m.insights;
        const card = (
          <>
            <Thumb media={m} />
            {stats ? (
              <div className="cdash-gstats">
                {stats.likes != null && <span className="cdash-gstat"><FiHeart size={12} /> {formatCompact(stats.likes)}</span>}
                {stats.comments != null && <span className="cdash-gstat"><FiMessageCircle size={12} /> {formatCompact(stats.comments)}</span>}
                {stats.reach != null && <span className="cdash-gstat"><FiEye size={12} /> {formatCompact(stats.reach)}</span>}
              </div>
            ) : null}
          </>
        );
        return m.permalink ? (
          <a className="cdash-gcard" href={m.permalink} target="_blank" rel="noreferrer" key={m.id} data-testid={`cdash-gcard-${m.id}`}>
            {card}
          </a>
        ) : (
          <div className="cdash-gcard" key={m.id} data-testid={`cdash-gcard-${m.id}`}>
            {card}
          </div>
        );
      })}
    </div>
  );
};
